import { Stack, Text } from "@mantine/core";
import React, { useEffect } from "react";
import { useAppSelector } from "../../../../hooks";
import { AkustikkGenerellInfo } from "./AkustikkGenerellInfo";
import { AkustikkKapitler } from "./AkustikkKapitler";
import { AkustikkProsjektinfo } from "./AkustikkProsjektInfo";

const AkustikkPremissrapport: React.FC<{ onUpdateEditData?: (data: any) => void }> = ({ onUpdateEditData }) => {
  const edited = useAppSelector((s) => s.reportReducer.editedData[401]);

  useEffect(() => {
    onUpdateEditData?.(edited);
  }, [edited]);

  return (
    <Stack p="md" style={{ maxWidth: 600, width: "100%", margin: "0 auto" }}>
      <Text fw={600} size="xl" ta="center">
        Akustikk Premissrapport
      </Text>
      <AkustikkGenerellInfo />
      <AkustikkProsjektinfo />
      <AkustikkKapitler />
    </Stack>
  );
};

export default AkustikkPremissrapport;
